import { render, staticRenderFns } from "./experts.vue?vue&type=template&id=bc26a48c&"
import script from "./experts.vue?vue&type=script&lang=js&"
export * from "./experts.vue?vue&type=script&lang=js&"
import style0 from "./experts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports